import { FETCH_USER_MIPS, FETCH_USER_MIPS_START, FETCH_USER_MIPS_SUCCESS, FETCH_USER_MIPS_ERROR } from '../../actions/admin/userMipActions';
import { paginationSize } from '../../../constants/constants';
import _ from 'lodash';

const INIT_STATE = {
    error: "",
    loading: false,
    submitting: false,
    message: '',
    userMips:[]
};

const userMipsReducer = (state = INIT_STATE, action) => {
    let newState;
    let newUsers;
    let index;
    switch (action.type) {
        case FETCH_USER_MIPS_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_USER_MIPS_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, userMips: action.userMips };
        }
        case FETCH_USER_MIPS_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }
        default:
            return state;
    }
}

export default userMipsReducer;
